import React, { useEffect, useState } from 'react'
import { faBooks } from '@fortawesome/pro-solid-svg-icons'
import { RankmiTable } from '@rankmi/rankmi-table'

import { generateTableLocale } from 'helpers/translations.helper'
import { Area } from 'graphqlAPI'
import { canSkipOnRowSelected } from 'helpers'
import { useColumns } from './hooks/useColumns'
import { useTranslationRankmi, joinKeys } from 'helpers/translations.helper'
import { prefix } from './constants'
import styles from './index.module.scss'
import { useMonitoring } from 'components/monitoring/context'

type Id = Area['id']

type DataColumn = Area & {
  key: Id
  name: string
  action: Id
}

interface ITable {
  setPage(page: number): void
  setSearch(text: string): void
  setSort: (value: { field: string; order: 'ascend' | 'descend' }) => void
  setPerPage(perPage: number): void
  setFastFilters?(value: number): void
  setAllSelected?(state: boolean): void
  onDelete?(id: Id): void
  list: Area[]
  total?: number
  loading: boolean
  currentPage: number
}

const Table: React.FC<ITable> = ({
  setPage,
  setSearch,
  setSort,
  setPerPage,
  setFastFilters,
  setAllSelected,
  list,
  loading,
  total,
  currentPage,
}) => {
  const tRelative = useTranslationRankmi({
    prefix: joinKeys(prefix),
  })
  const [dataSource, setDataSource] = useState<DataColumn[]>([])
  const [translations, setTranslations] = useState<any>({})
  const { onSelectItem } = useMonitoring()

  useEffect(() => {
    setTranslations(() =>
      generateTableLocale({
        header: {
          rowsCount: tRelative('rowsCount'),
          rowsCount_plural: tRelative('rowsCount_plural'),
        },
      })
    )
  }, [tRelative])

  useEffect(() => {
    setDataSource(
      list.map(({ id, ...rest }) => ({
        id,
        key: id,
        ...rest,
        action: id,
      }))
    )
  }, [list])

  const columns = useColumns()

  return (
    <div className={styles.container}>
      <RankmiTable
        columnHeaders={columns}
        data={dataSource}
        total={total}
        currentPage={currentPage}
        changeColumnsVisibility
        onPaginationChange={(page: any) => setPage(page)}
        onSearch={(text: string) => setSearch(text)}
        onSortChange={(sortData: any) => setSort(sortData)}
        loading={loading}
        onRowsPerPageChange={setPerPage}
        onRowSelected={({
          allSelected,
          dispatcher,
          selectedRowKeys,
        }: {
          allSelected: boolean
          dispatcher: string
          selectedRowKeys: string[]
        }) => {
          onSelectItem(selectedRowKeys)
          if (canSkipOnRowSelected(dispatcher)) return
          setAllSelected?.(allSelected)
        }}
        locale={translations}
        countIcon={faBooks}
        initialRowsPerPage={10}
        simpleSelectAll
        onFastActionSelect={(selected: any) => setFastFilters?.(selected)}
        responsive
      />
    </div>
  )
}

export default Table
